<template lang="pug">
md-input-container
  label(for='serie') Series
  md-select#serie(v-model='selected', @selected='onSerieSelected', name='serie')
    md-option(v-for='serie in series', :value='serie._id', :key='serie._id') {{ serie.name }}
</template>

<script>
import serieService from '../../services/serieService';

  export default {
    props:{
      value: {
        type: [String, Array]
      },
    },
    data() {
      return {
        selected: this.value,
        series: [],
      }
    },
    methods: {
      onSerieSelected(value) {
        const selectedSerie = this.series.filter(serie => serie._id === value)[0];
        const isMiniSerie = selectedSerie.isMiniSerie ? selectedSerie.isMiniSerie : false;
        this.$emit('onSerieSelectorChange', {isMiniSerie, serieId: value});
      },
      search() {
        this.loading = true;
          serieService.getList()
          .then((response) => {
            const publicSeries = response.data.series.filter(serie => serie.status === "public")
            this.series = publicSeries;
          })
          .catch((error) => {
            console.error('Error while retrieving the list of networks', error);
          })
          .then(() => {
            this.loading = false;
          });
      },
    },
    mounted() {
      setTimeout(() => {
        this.search();
      }, 800);
    },
    watch: {
      value(newValue) {
        this.selected = newValue;
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/shared-components/serie/SerieSelector.vue